module.exports = __webpack_public_path__ + "img/13.e1741146.jpg";